<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Manage Limit"
              bc1="App"
              bc2="Manage Limit"
              bc3="Add"
              path="acquirings"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Manage Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Min Limit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="min"

                                  class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Max Limit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="max"

                                  class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Status</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select class="form-control" v-model="status">
                                <option :key="index" :value="index" v-for="(item, index) in statusList">
                                  {{ item }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <PaymentMethodSettings
                          v-if="renderSettings"
                          :modelValue.sync="paymentMethodSelectedSettings"
                          ref="payemntSetting"
                          :hidePaymentMethodDropdown="true"
                      />

                      <div class="col-sm-9 offset-sm-3 d-flex justify-content-end mt-1">
                        <button
                            type="button"
                            class="btn btn-primary "
                            @click="saveData"
                            :disabled="loading"
                        >
                          <span class="d-inline-flex"><Loader :loading="loading" :size="size"></Loader></span>
                          Save Details
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

export default {

  mounted() {
    var schemaAcquiringTransactionTypesLimits = this.$store.getters.getByKey(
        "schemaAcquiringTransactionTypesLimits"
    );
    this.schemaAquiringId = parseInt(this.$route.params.acquiringId)
    this.aquiringTransactionTypeId = schemaAcquiringTransactionTypesLimits.row.pivot.id
    this.getLimits()
    // this.getAcquirings()

    var schemaAcquiringTransactionTypes = this.$store.getters.getByKey(
        "schemaAcquiringTransactionTypes"
    );
    this.code = schemaAcquiringTransactionTypes.row.aquiring.payment_method.code

    this.paymentId = schemaAcquiringTransactionTypes.row.aquiring.payment_method.id
    this.paymentMethodSelectedSettings.paymentId = this.paymentId


  },
  data() {
    return {
      code: "",
      type: "",
      loading: false,
      size: "10px",
      schemaId: "",
      min: '',
      max: '',
      acqurings: [],
      aquiringTransactionTypeId:'',
      schemaAquiringId:'',
      limitData:null,
      paymentMethodSelectedSettings: {},
      renderSettings:false,
      paymentId: "",
      settings: {},
      statusList: ['Inactive', 'Active'],
      status: 1,

    };
  },
  methods: {
    saveData(){
      if (this.$refs.payemntSetting.clear) {
        this.settings = null
        this.paymentMethodSelectedSettings.settings = this.settings
        let requestData ={
          aquiringTransactionTypeId : this.aquiringTransactionTypeId,
          schemaAquiringId : this.schemaAquiringId,
          minLimit : this.min*100,
          maxLimit : this.max*100,
          status : this.status,
          settings: null,
        }

        this.loading = true
        this.makeRequest(
            "post",
            "v1/add-schema-aquiring-limits",
            requestData,
        ).then(callResponse => {
          this.loading = false
          if (!callResponse.error) {
            let code = callResponse.response.data.code;

            if (code == 200) {
              this.$router.back()
            }
          }
        });



        return
      }


      let validPaymentFileds = this.$refs.payemntSetting.validateAllFields()

      validPaymentFileds.validateAll().then(valid => {
        if (this.paymentMethodSelectedSettings.allFieldsCodes.includes(this.code)) {
          if (valid) {
            let requestData ={
              aquiringTransactionTypeId : this.aquiringTransactionTypeId,
              schemaAquiringId : this.schemaAquiringId,
              minLimit : this.min*100,
              maxLimit : this.max*100,

            }


            if (this.paymentMethodSelectedSettings.allFieldsCodes.includes(this.code)) {
              requestData.settings = JSON.stringify(this.settings)
            }
            this.loading = true
            this.makeRequest(
                "post",
                "v1/add-schema-aquiring-limits",
                requestData,
            ).then(callResponse => {
              this.loading = false
              if (!callResponse.error) {
                let code = callResponse.response.data.code;

                if (code == 200) {
                  this.$router.back()
                }
              }
            });




          }
        } else {
          let requestData ={
            aquiringTransactionTypeId : this.aquiringTransactionTypeId,
            schemaAquiringId : this.schemaAquiringId,
            minLimit : this.min*100,
            maxLimit : this.max*100,

          }

          this.loading = true
          this.makeRequest(
              "post",
              "v1/add-schema-aquiring-limits",
              requestData,
          ).then(callResponse => {
            this.loading = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;

              if (code == 200) {
                this.$router.back()
              }
            }
          });

        }
      })


    },
    getLimits() {
      let data ={
        aquiringTransactionTypeId : this.aquiringTransactionTypeId,
        schemaAquiringId : this.schemaAquiringId,
      }
      this.makeRequest(
          "post",
          "v1/get-schema-aquiring-limits",
          data,
          {},
          false
      ).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.limitData = callResponse.response.data.data
            if(this.limitData){
              this.min = parseFloat(this.limitData.min_limit/100).toFixed(this.amountDecimalPlaces)
              this.max = parseFloat(this.limitData.max_limit/100).toFixed(this.amountDecimalPlaces)
              this.status = this.limitData.status

              let temp = {}
              temp.paymentId = this.paymentId

              if (this.limitData.other_settings) {
                temp.settings = this.limitData.other_settings
              }
              this.paymentMethodSelectedSettings = temp
              this.renderSettings =true
            }
          }
        }
            this.renderSettings =true
      }

      );
    },
    getAcquirings() {
      this.makeRequest("post", "v1/get-aquiring", {status: "active"}, {}, false).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {

                let acqruings = callResponse.response.data.data
                this.acqurings = acqruings
                // if (this.acqurings) {
                //   this.selectedAcquiring = this.acqurings[0].id
                // }
              }
            }
          }
      );
    }


  },
  watch: {
    paymentMethodSelectedSettings(val) {
      this.paymentId = val.paymentId
      this.settings = val.settings
    }
  }

};
</script>

